module.exports = __webpack_public_path__ + "static/docu-e4e3db6eaea9e2621ca67a47e1b8cf1a.jpeg";